<template>
  <Modal v-model="model" title="查看日誌" width="90%" :styles="{top: '10px'}">
    <lida-table :propscolumns="columns" :data="datatable">
      <template v-slot:headerSelect>
        <DatePicker
          type="date"
          placeholder="选择起头日期"
          format="yyyy-MM-dd"
          style="width: 200px"
          :value="startDate"
          @on-change="val => startDate = val"
          :clearable="false"
          class="mr-2"
        ></DatePicker>
        <DatePicker
          type="date"
          placeholder="选择结尾日期"
          format="yyyy-MM-dd"
          :value="endDate"
          @on-change="val => endDate = val"
          :clearable="false"
          class="mr-2"
        ></DatePicker>
        <Button type="primary" @click="searchdate" :loading="loading">查询</Button>
      </template>
    </lida-table>
    <div slot="footer">
      <Button type="primary" @click="model = !model">關閉</Button>
    </div>
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment-timezone";
export default {
  name: 'ModalSiteLog',
  data () {
    return {
      model: false,
      columns: {
        date: {
          title: '日期/时间',
          key: 'date',
          align: 'center',
          width: 280
        },
        chname: {
          title: '操作者名称',
          key: 'chname',
          align: 'center',
        },
        chuser: {
          title: '站点名称',
          key: 'chuser',
          align: 'center',
        },
        mlevel: {
          title: '用户级别',
          key: 'mlevel',
          align: 'center',
        },
        action: {
          title: '操作',
          key: 'action',
          align: 'center',
        },
        oldvalue: {
          title: '变动前值',
          key: 'oldvalue',
          align: 'center',
        },
        newvalue: {
          title: '变动后值',
          key: 'newvalue',
          align: 'center',
        },
      },
      loading: false,
      datatable: [],
      startDate: '',
      endDate: '',
      siteid: null
    };
  },
  computed: {
    ...mapGetters(["getacounts", "getmember"]),
  },
  methods: {
    ...mapActions(["chg_acounts"]),
    modelDate (id) {
      this.siteid = id
      this.model = true
      this.startDate = moment().date(1).format("YYYY-MM-DD")
      this.endDate = moment().format("YYYY-MM-DD")
      this.searchdate()
    },
    async searchdate () {
      try {
        this.loading = true
        const res = await this.$axios.acount.stop_logoddchtable(this.startDate, this.endDate, this.siteid)
        if ('status' in res && res.status === 0) return
        this.datatable = res.reverse()
      } catch (error) {
        console.error(error)
      } finally {
        setTimeout(() => this.loading = false, 2000)
      }
    }
  }
};
</script>
